export default () => ({
  modulesHMLVersion: {},
});
